export default __webpack_public_path__ + "static/media/workouttimes_2@3x.f904562c.jpg";